import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'user_membership';
export const route = 'user_membership/[[...slug]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "userarea" */
'../../components/UserMembership')));